export default "__VITE_ASSET__BkMUUCPg__"